// src/data/PrivacyContent.js

import React from 'react';

const PrivacyContent = () => {
  return (
    <div className="legal-content">
      <h2>🛡️ Privacy Policy — Naoko (AI Agent)</h2>

      <h3>1. Introduction</h3>
      <p>
        Naoko is a virtual assistant designed to help users apply for government schemes, scholarships, PAN cards, and various official certificates in India. Your privacy is important to us, and we are committed to protecting the information you share with us.
      </p>

      <h3>2. Information We Collect</h3>
      <ul>
        <li><strong>Personal Identification Information:</strong> Name, phone number, and state of residence.</li>
        <li><strong>Official Documents:</strong> Scanned or photographed copies of ID cards, income certificates, tribe certificates, address proof, and other supporting documents required for applications.</li>
        <li><strong>Application Metadata:</strong> Type of service requested, status of applications, timestamps, and user-generated input during chats.</li>
        <li><strong>Login Credentials:</strong> We store credentials required for authentication within our system (excluding OTP).</li>
      </ul>

      <h3>3. How We Use Your Information</h3>
      <p>We use your data solely to:</p>
      <ul>
        <li>Assist in form-filling and submission of various government applications.</li>
        <li>Communicate with you through the chatbot.</li>
        <li>Maintain records of applications submitted on your behalf.</li>
        <li>Provide you with your application number to check status or download forms.</li>
        <li>Improve the chatbot experience and internal system accuracy.</li>
      </ul>
      <p><em>We do not use your data for advertising or sell it to third parties.</em></p>

      <h3>4. Data Storage and Retention</h3>
      <ul>
        <li>Documents and data are temporarily stored during the processing of the application.</li>
        <li>Once the application is successfully submitted and confirmed, documents are deleted from our servers.</li>
        <li>We plan to implement local device storage in the future, allowing users to reuse uploaded documents without re-uploading them to our servers.</li>
        <li>Minimal metadata such as application ID and service history may be retained for support and record-keeping purposes.</li>
      </ul>

      <h3>5. Security</h3>
      <ul>
        <li>We use industry-standard practices to secure user data, including encrypted communication channels and token-based authentication.</li>
        <li>Uploaded documents are securely stored and automatically deleted after processing is complete.</li>
        <li>Access to data is limited strictly to the system operations required to fulfill your requests.</li>
      </ul>

      <h3>6. Third-Party Tools</h3>
      <ul>
        <li>We may use secure third-party services to assist in payment processing, application automation, or backend infrastructure.</li>
        <li>All third-party services we work with are compliant with industry security standards and operate under strict privacy agreements.</li>
        <li>Naoko may interact with government portals to complete your application on your behalf.</li>
      </ul>

      <h3>7. User Rights</h3>
      <p>You have the right to:</p>
      <ul>
        <li>Request deletion of your data (including uploaded documents).</li>
        <li>Access information related to your application status.</li>
        <li>Contact us regarding any concerns related to data handling.</li>
      </ul>

      <h3>8. Children’s Privacy</h3>
      <p>
        Naoko is not intended for use by individuals under the age of 18 without supervision. We do not knowingly collect personal data from minors.
      </p>

      <h3>9. Changes to This Policy</h3>
      <p>
        We may update this policy as our system evolves. Any major changes will be communicated clearly on our platform.
      </p>

      <h3>10. Contact Us</h3>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us at:
      </p>
      <ul>
        <li>📧 Email: <a href="mailto:support@naoko.live">support@naoko.live</a></li>
        <li>🌐 Website: <a href="https://naoko.live" target="_blank" rel="noopener noreferrer">https://naoko.live</a></li>
      </ul>

      <p style={{ marginTop: '1rem' }}>
        Effective Date: April 11, 2025
      </p>
    </div>
  );
};

export default PrivacyContent;
